import { pdpSharedNotificationMultiplePdpVisitsModalConfig as pdpSharedMultiplePdpVisitsModalConfig } from './PdpSharedNotificationMultiplePdpVisitsModal/pdpSharedNotificationMultiplePdpVisitsModalConfig';
import { pdpSharedNotificationPdpSourcingModalConfig as pdpSharedSourcingModalConfig } from './PdpSharedNotificationPdpSourcingModal/pdpSharedNotificationPdpSourcingModalConfig';
import { config as pdpTradeOnboardingModalConfig } from './PdpSharedNotificationTradeOnboardingModal/config';
import { pdpSharedNotificationTradeMicroGoalConfig } from './PdpSharedNotificationTradeMicroGoal/pdpSharedNotificationTradeMicroGoalConfig';

export const pdpSharedNotifications = [
    pdpSharedMultiplePdpVisitsModalConfig,
    pdpSharedSourcingModalConfig,
    pdpTradeOnboardingModalConfig,
    pdpSharedNotificationTradeMicroGoalConfig,
];
